/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PendingComplianceInformationResource
 */
export interface PendingComplianceInformationResource {
    /**
     * 
     * @type {boolean}
     * @memberof PendingComplianceInformationResource
     */
    internalComplianceDocumentPending?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PendingComplianceInformationResource
     */
    externalComplianceDocumentPending?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PendingComplianceInformationResource
     */
    umbrellaDocumentPending?: boolean;
}

/**
 * Check if a given object implements the PendingComplianceInformationResource interface.
 */
export function instanceOfPendingComplianceInformationResource(value: object): value is PendingComplianceInformationResource {
    return true;
}

export function PendingComplianceInformationResourceFromJSON(json: any): PendingComplianceInformationResource {
    return PendingComplianceInformationResourceFromJSONTyped(json, false);
}

export function PendingComplianceInformationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PendingComplianceInformationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'internalComplianceDocumentPending': json['internalComplianceDocumentPending'] == null ? undefined : json['internalComplianceDocumentPending'],
        'externalComplianceDocumentPending': json['externalComplianceDocumentPending'] == null ? undefined : json['externalComplianceDocumentPending'],
        'umbrellaDocumentPending': json['umbrellaDocumentPending'] == null ? undefined : json['umbrellaDocumentPending'],
    };
}

export function PendingComplianceInformationResourceToJSON(value?: PendingComplianceInformationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'internalComplianceDocumentPending': value['internalComplianceDocumentPending'],
        'externalComplianceDocumentPending': value['externalComplianceDocumentPending'],
        'umbrellaDocumentPending': value['umbrellaDocumentPending'],
    };
}

